import { useRef, useEffect, useState } from "react";

const Jobs = () => {
  return (
    <div className="jobs-container"> {/* <= CHANGE THIS */}
    </div>
  );
};

export default Jobs;